import { render, staticRenderFns } from "./HeaderStep.vue?vue&type=template&id=30c28f7e"
import script from "./HeaderStep.vue?vue&type=script&lang=ts"
export * from "./HeaderStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports